import O1HD, { managers } from "../../../../../engines/gameEngine";
import physics_tool from "../../../../../engines/libs/physics_tool";
import { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import level_flyknife from "./level_flyknife";

const { ccclass, property, menu } = cc._decorator;

/**飞刀 撞击反弹加速道具*/
@ccclass
export default class level_flyknife3 extends level_flyknife {

    protected start(): void {

        (<any>this.node_flyKnife.getComponent(cc.Component)).onCollisionEnter = this.CollisionEnterFun.bind(this)
    }
 
    CollisionEnterFun(other:cc.BoxCollider, self:cc.BoxCollider) {
        // this.showCombo(this.comboNum)
        let that =this
        if (other.node.name == "targetNode") {
            this.smokeAni.node.active = true

            this.smokeAni.node.setPosition(other.node.position.x,other.node.position.y)
            this.smokeAni.setAnimation(0, "play", false)
            this.scheduleOnce(() => {
                if (other.node) {
                    this.killNum += 1
                    other.node.destroy()
                    managers().soundMgr.playSound('flyKnife', null, BUNDLE_SMALL_NAME.fddsMode);
                    if (this.killNum >= this.successKillNum) {
                        this.gameOver(true)
                    }
                }

            }, 0.2)

        } else if (other.node.name == "playNode") {
            this.smokeAni.node.setPosition(other.node.position.x, other.node.position.y)
            this.smokeAni.node.active = true
            this.smokeAni.setAnimation(0, "play", false)
            this.scheduleOnce(() => {
                other.node && other.node.destroy()
            }, 0.2)
        } else if (other.node.name == "jiasutiao") {  //加速道具
            
            this.node_flyKnife.linearVelocity = this.node_flyKnife.linearVelocity.mul(1.1)
            return
        }
        else if (other.node.name == "xiaoshi") {  //消失道具
            other.enabled =false
            this.scheduleOnce(()=>{
                other.node.destroy()
            },0.01)
            managers().soundMgr.playSound('tandao', null, BUNDLE_SMALL_NAME.fddsMode);
            return
        }
        else if (other.node.name == "fenlie") {  //分裂道具
        
            let newNode = cc.instantiate( self.node)
            newNode.getComponent(cc.RigidBody).linearVelocity = cc.v2(-this.node_flyKnife.linearVelocity.x,-this.node_flyKnife.linearVelocity.y)
            newNode.parent =self.node.parent
  
            other.enabled =false
            this.scheduleOnce(()=>{
                other.node.destroy()
            },0.01)
            managers().soundMgr.playSound('tandao', null, BUNDLE_SMALL_NAME.fddsMode);
            (<any>newNode.getComponent(cc.Component)).onCollisionEnter = this.CollisionEnterFun.bind(that)
            return
        }

        switch (Number(other.tag)) {
            case 2: //碰到自己
                managers().soundMgr.playSound('flyKnife', null, BUNDLE_SMALL_NAME.fddsMode);
               
                this.gameOver(false)
                break;
            case 3: //碰到敌人


                break;
            case 4: //碰到苹果
                managers().soundMgr.playSound('cutApple', null, BUNDLE_SMALL_NAME.fddsMode);
                this.gameOver(true)
                this.appleKnife && (this.appleKnife.active = true)
                break;
            default:

                managers().soundMgr.playSound('tandao', null, BUNDLE_SMALL_NAME.fddsMode);
        }
    }


    onDestroy() {
        physics_tool.closePhysics();
    }


}